import clsx from 'clsx'
import Button from 'components/forms/Button'
import CheckButton from 'components/forms/CheckButton'
import MinusIcon from 'components/icons/MinusIcon'
import PlusIcon from 'components/icons/PlusIcon'
import { isPresent } from 'lib/utils'
import { useCallback, useMemo } from 'react'
import { IProductIngInfo, IProductIngredient } from './types'

type Props = {
  onClick: (ing: IProductIngInfo, quantity: number) => void
  ing: IProductIngInfo
  groupsingsProps: { [name: number]: IProductIngredient }
  selectedIngs: [IProductIngInfo, number][]
}

const ProductIng = ({
  ing,
  groupsingsProps,
  onClick,
  selectedIngs,
}: Props) => {
  const { ingredientId, ingredientVariationId } = ing

  const quantity = useMemo(() => {
    const _ing = selectedIngs.find(
      ([ing, _quantity]) => ing.ingredientId === ingredientId
    )
    return isPresent(_ing) ? _ing[1] : 0
  }, [ingredientId, selectedIngs])

  const price =
    groupsingsProps[ingredientId]?.meta[ingredientVariationId]?.price

  const weight = groupsingsProps[ingredientId]?.meta[ingredientVariationId]?.weight

  const onCheckBoxClick = useCallback(() => {
    if (quantity === 0) onClick(ing, 1)
    else onClick(ing, 0)
  }, [quantity, onClick, ing])

  const ingName = useMemo(() => {
    // const splitted = isPresent(groupsingsProps[ingredientId]?.name)
    //   ? groupsingsProps[ingredientId]?.name.split(' ')
    //   : undefined
    // return isPresent(splitted) && splitted.length > 1
    //   ? splitted?.slice(1).join(' ')
    //   : splitted?.join(' ')

      return groupsingsProps[ingredientId]?.name
  }, [groupsingsProps, ingredientId])

  return (
    <div className='flex flex-row justify-between pt-1'>
      <div className='flex items-start'>
        <CheckButton
          checked={quantity > 0}
          onClick={onCheckBoxClick}
        />

        <label
          className={clsx(
            'cursor-pointer pt-[4px] mx-3 text-dark text-sm w-[120px] md:w-[180px] xl:w-[300px] tracking-tight',
            {
              'font-light': quantity == 0,
              'font-semibold': quantity > 0,
            }
          )}
          htmlFor={`ing-${ingredientId}`}
          title={ingName}
        >
          {ingName}{isPresent(weight) ? `, ${weight} г` : null}
        </label>
      </div>

      <div className='flex items-center justify-end gap-5 flex-shrink-0'>
        <div className='flex items-center gap-1 flex-shrink-0'>
          <Button
            aria-label='Уменьшить количество'
            onClick={() => onClick(ing, -1)}
            disabled={quantity === 0}
          >
            <MinusIcon
              className={clsx('w-3 h-3', {
                'text-bodyGrey': quantity === 0,
              })}
            />
          </Button>

          <div className='text-sm leading-none tracking-tight text-dark'>
            {quantity}
          </div>

          <Button
            aria-label='Увеличить количество'
            onClick={() => onClick(ing, 1)}
          >
            <PlusIcon className='w-3 h-3' />
          </Button>
        </div>

        <div className='w-[60px] lg:w-[90px] text-right text-sm font-light text-dark whitespace-nowrap tracking-tight'>
          {`${price} ₽`}
        </div>
      </div>
    </div>
  )
}

export default ProductIng
